import React from "react";
import TodoList from "@/components/process-trigger/todo-list";

// Pending starts from process triggers, for any signed-in user whatever their role.
const ToDoPage: React.FC = () => (
  <div className="p-4 lg:p-8 max-w-screen-md mx-auto">
    <TodoList />
  </div>
);

export default ToDoPage;
